import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/shared/failure.svg'


const _hoisted_1 = { class: "flex flex-col min-h-screen bg-gray-100" }
const _hoisted_2 = { class: "flex flex-col w-full border-b" }
const _hoisted_3 = {
  key: 0,
  class: "fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
}
const _hoisted_4 = {
  key: 1,
  role: "alert",
  class: "flex gap-2 w-full justify-center p-2.5 mt-6 text-sm leading-5 text-center text-red-900 bg-red-50 rounded-lg max-md:flex-wrap",
  style: {"max-height":"80px","overflow-y":"auto"}
}
const _hoisted_5 = { class: "flex flex-col gap-6 mb-16 p-6" }
const _hoisted_6 = { class: "flex flex-row items-center gap-2" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "flex flex-row max-w-max gap-2 bg-gray-200 rounded-lg p-1" }
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = { class: "flex flex-row gap-2" }
const _hoisted_12 = {
  key: 0,
  class: "grid grid-cols-1 md:grid-cols-3 gap-6 w-full"
}
const _hoisted_13 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-3 gap-6 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_SubscriptionPlanCard = _resolveComponent("SubscriptionPlanCard")!
  const _component_SubscriptionDetailsModal = _resolveComponent("SubscriptionDetailsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", _hoisted_2, [
        _createVNode(_component_Navbar, { activeTab: 0 })
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[3] || (_cache[3] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-primary-purple" }, null, -1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Error Icon",
                class: "w-4 h-4"
              })
            ], -1)),
            _createElementVNode("p", null, _toDisplayString(_ctx.errorMessage), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-black text-3xl font-semibold leading-9 text-left" }, "Subscription", -1)),
          (_ctx.currentSubscriptionStatus)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["rounded-md px-2 py-1 text-sm font-medium leading-5 text-left", 
            _ctx.currentSubscriptionStatus === 'active'
              ? 'bg-green-200 text-green-900'
              : 'bg-red-200 text-red-900'
          ])
              }, _toDisplayString(_ctx.currentSubscriptionStatus?.toUpperCase()), 3))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_BaseButton, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMonthlyPlans())),
                class: _normalizeClass(["px-4 py-1 text-black text-sm font-medium leading-5", 
                _ctx.isMonthlyPlansSelected
                  ? 'bg-primary-purple text-white rounded-md'
                  : 'bg-gray-200'
              ])
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode(" Monthly Subscription ")
                ])),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_BaseButton, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showYearlyPlans())),
                class: _normalizeClass(["px-4 py-1 text-gray-900 text-sm font-medium leading-5", 
                _ctx.isYearlyPlansSelected
                  ? 'bg-primary-purple text-white rounded-md'
                  : 'bg-gray-200'
              ])
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode(" Yearly Subscription ")
                ])),
                _: 1
              }, 8, ["class"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.isMonthlyPlansSelected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthlyPlansList, (plan, index) => {
                    return (_openBlock(), _createBlock(_component_SubscriptionPlanCard, {
                      key: index,
                      plan: plan,
                      "is-selected": 
                _ctx.selectedPlan?.subscriptionPlanTierId ===
                plan.subscriptionPlanTierId
              ,
                      "current-amount": _ctx.getCurrentMonthlyAmount(),
                      customAmount: _ctx.currentSubscriptionAmount,
                      onSelect: _ctx.reviewPaymentMethod,
                      onContactSupport: _ctx.handleContactSupport,
                      onViewPaymentMethod: _ctx.reviewPaymentMethod
                    }, null, 8, ["plan", "is-selected", "current-amount", "customAmount", "onSelect", "onContactSupport", "onViewPaymentMethod"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.isYearlyPlansSelected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearlyPlansList, (plan, index) => {
                    return (_openBlock(), _createBlock(_component_SubscriptionPlanCard, {
                      key: index,
                      plan: plan,
                      "is-selected": 
                _ctx.selectedPlan?.subscriptionPlanTierId ===
                plan.subscriptionPlanTierId
              ,
                      "current-amount": _ctx.getCurrentMonthlyAmount(),
                      customAmount: _ctx.currentSubscriptionAmount,
                      onSelect: _ctx.reviewPaymentMethod,
                      onContactSupport: _ctx.handleContactSupport,
                      onViewPaymentMethod: _ctx.reviewPaymentMethod
                    }, null, 8, ["plan", "is-selected", "current-amount", "customAmount", "onSelect", "onContactSupport", "onViewPaymentMethod"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_SubscriptionDetailsModal, {
      isVisible: _ctx.isPaymentMethodModalVisible,
      source: _ctx.paymentMethodSource,
      cardNumber: _ctx.paymentMethodCardNumber,
      cardExpiry: _ctx.paymentMethodCardExpiry,
      invoiceRecipientEmail: _ctx.paymentMethodInvoiceRecipientEmail,
      showBillingButton: true,
      upcomingInvoice: _ctx.mappedUpcomingInvoice,
      isLoading: _ctx.isModalLoading,
      onProceed: _ctx.proceedWithPaymentMethod,
      "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isPaymentMethodModalVisible = false))
    }, null, 8, ["isVisible", "source", "cardNumber", "cardExpiry", "invoiceRecipientEmail", "upcomingInvoice", "isLoading", "onProceed"])
  ], 64))
}